import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { AnalysisHeaderComponent } from '../analysis-header/analysis-header.component';
import { GptRouterBackModule } from '@geneplanet/ngx-utils';
import { AnalysisHeaderTitleComponent } from '../analysis-header/components/title/title.component';
import { GpuLayoutModule } from '@geneplanet/ngx-ui';

@Component({
  selector: 'app-image-header',
  templateUrl: './image-header.component.html',
  styleUrls: ['./image-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AnalysisHeaderComponent,
    AnalysisHeaderTitleComponent,
    GptRouterBackModule,
    GpuLayoutModule,
  ],
  standalone: true,
})
export class ImageHeaderComponent {
  @Input() imgS: string;
  @Input() imgL: string;
  @Input() title: string;
  @Input() routerBackUrl: string;

  @ViewChild('imageHeaderContainer') imageHeaderContainer: ElementRef;
  @ViewChild('contentContainer') contentContainer: ElementRef;
  @ViewChild('backContainer') backContainer: ElementRef;
  @ViewChild('analysisHeaderContainer') analysisHeaderContainer: ElementRef;

  linearGradient =
    'linear-gradient(180deg, rgba(58, 67, 113, 0) 0.03%, rgba(58, 67, 113, 0.75) 100%)';
  analysisHeaderTop = -1;

  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener('window:scroll')
  windowScroll() {
    this.onScroll();
  }

  public updateHeight() {
    this.analysisHeaderTop =
      this.analysisHeaderContainer.nativeElement?.offsetHeight * -1;
    this.cdr.markForCheck();
  }

  private onScroll() {
    setTimeout(() => {
      const imageHeaderHeight =
        this.imageHeaderContainer?.nativeElement?.offsetHeight;
      const contentHeight = this.contentContainer?.nativeElement?.offsetHeight;
      const backHeight = this.backContainer?.nativeElement?.offsetHeight;
      const analysisHeaderHeight =
        this.analysisHeaderContainer?.nativeElement?.offsetHeight;

      const previousValue = this.analysisHeaderTop;
      this.analysisHeaderTop =
        window.scrollY + backHeight >= imageHeaderHeight - contentHeight
          ? 0
          : analysisHeaderHeight * -1;

      if (previousValue != this.analysisHeaderTop) {
        this.cdr.markForCheck();
      }
    });
  }
}
